import React from 'react';
import Timesheets from './Timesheets';

const MyTime = () => {
  // scopeToSelf, because showAdminTabs={false} only hid the admin TABS. The table underneath
  // still ran the company-wide query, so /my/time showed every employee's entries to anyone
  // who was not role EMPLOYEE — an owner clicking "Hours This Week" on My Dashboard got the
  // team's hours under a heading about their own (board #514).
  return <Timesheets initialTab="timesheets" showAdminTabs={false} scopeToSelf />;
};

export default MyTime;
